/* ============================================================
   NutraHarmony Berberine Blend — shared funnel interactions
   Accordion (smooth CSS-grid height) · Swiper init · sticky CTA ·
   smooth-scroll. Order-form logic lives in berberine-of.js.
   ============================================================ */
(function () {
  'use strict';

  var swiperLoading = false;
  var swiperQueue = [];

  /* ---- Accordion (single-open per .berberine-faq group; .berberine-faq--multi allows many open) ---- */
  function initAccordion() {
    document.querySelectorAll('.berberine-faq__head').forEach(function (head) {
      if (head.__ppchBound) return;
      head.__ppchBound = true;
      head.addEventListener('click', function () {
        var item = head.closest('.berberine-faq__item');
        var group = head.closest('.berberine-faq');
        var open = item.classList.contains('is-open');
        if (group && !group.classList.contains('berberine-faq--multi')) {
          group.querySelectorAll('.berberine-faq__item.is-open').forEach(function (i) {
            if (i !== item) {
              i.classList.remove('is-open');
              var sibHead = i.querySelector('.berberine-faq__head');
              if (sibHead) sibHead.setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.classList.toggle('is-open', !open);
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---- Swiper (loads from CDN, data-driven config) ----
     Supported data-* on a .berberine-swiper element:
       data-per-view   number | "auto"     (default 1)
       data-gap        px spaceBetween      (default 0)
       data-loop       "true" to loop
       data-autoplay   delay ms (presence enables autoplay)
       data-speed      transition ms        (default 500)
       data-effect     "fade"
       data-direction  "vertical"
       data-thumb-strip  marks a thumbnail strip (free-mode, watch progress)
       data-thumbs     CSS selector of the thumb strip this main slider syncs to
     Nav arrows: place .swiper-button-prev/next as siblings (in the parent).  */
  function initSwipers() {
    var nodes = document.querySelectorAll('.berberine-swiper');
    if (!nodes.length) return;
    function num(el, attr, def) {
      var v = el.getAttribute(attr);
      if (v === null || v === '') return def;
      if (v === 'auto') return 'auto';
      var n = parseFloat(v);
      return isNaN(n) ? def : n;
    }
    function buildOne(el) {
      if (el.__swiper) return;
      var opts = {
        slidesPerView: num(el, 'data-per-view', 1),
        spaceBetween: parseInt(el.getAttribute('data-gap') || '0', 10),
        loop: el.getAttribute('data-loop') === 'true',
        speed: parseInt(el.getAttribute('data-speed') || '500', 10),
        observer: true,
        observeParents: true,
        observeSlideChildren: true
      };
      if (el.hasAttribute('data-autoplay')) {
        opts.autoplay = { delay: parseInt(el.getAttribute('data-autoplay') || '3500', 10), disableOnInteraction: false };
      }
      if (typeof opts.slidesPerView === 'number' && opts.slidesPerView > 1) {
        opts.breakpoints = {
          0: { slidesPerView: 1 },
          640: { slidesPerView: Math.min(2, opts.slidesPerView) },
          1000: { slidesPerView: opts.slidesPerView }
        };
      }
      if (el.getAttribute('data-effect') === 'fade') { opts.effect = 'fade'; opts.fadeEffect = { crossFade: true }; }
      if (el.getAttribute('data-direction') === 'vertical') opts.direction = 'vertical';
      if (el.hasAttribute('data-thumb-strip')) { opts.watchSlidesProgress = true; opts.freeMode = true; opts.slideToClickedSlide = true; }
      if (!el.hasAttribute('data-thumb-strip')) {
        var nextEl = el.querySelector('.swiper-button-next');
        var prevEl = el.querySelector('.swiper-button-prev');
        if (nextEl || prevEl) opts.navigation = { nextEl: nextEl, prevEl: prevEl };
      }
      var pag = el.querySelector('.swiper-pagination');
      if (pag) opts.pagination = { el: pag, clickable: true };
      var thumbSel = el.getAttribute('data-thumbs');
      if (thumbSel) {
        var tEl = document.querySelector(thumbSel);
        if (tEl) { buildOne(tEl); if (tEl.__swiper) opts.thumbs = { swiper: tEl.__swiper }; }
      }
      el.__swiper = new Swiper(el, opts);
    }
    function build() { nodes.forEach(buildOne); }
    if (typeof Swiper === 'undefined') {
      if (!document.querySelector('link[rel="stylesheet"][href*="swiper-bundle"]')) {
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(l);
      }
      swiperQueue.push(build);
      if (swiperLoading) return;
      swiperLoading = true;
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      s.onload = function () {
        var queue = swiperQueue.slice();
        swiperLoading = false;
        queue.forEach(function (fn) { fn(); });
        swiperQueue = [];
      };
      document.head.appendChild(s);
    } else {
      build();
    }
  }

  /* ---- /of hero image gallery (self-contained: no Swiper) ----
     Stacked slides + prev/next arrows (hidden at first/last) + thumbnail strip.
     Active thumb gets the .is-active class; arrows toggle .is-hidden. ---- */
  function initHofGallery() {
    document.querySelectorAll('[data-hof-gallery]').forEach(function (g) {
      if (g.__ppchHof) return;
      g.__ppchHof = true;
      var slides = [].slice.call(g.querySelectorAll('[data-hof-slide]'));
      var thumbs = [].slice.call(g.querySelectorAll('[data-hof-thumb]'));
      var prev = g.querySelector('[data-hof-prev]');
      var next = g.querySelector('[data-hof-next]');
      var track = g.querySelector('[data-hof-track]');
      var viewport = g.querySelector('.berberine-hof__viewport');
      var thumbsEl = g.querySelector('.berberine-hof__thumbs');
      var thumbtrack = g.querySelector('[data-hof-thumbtrack]');
      var n = slides.length;
      if (!n || !track) return;
      var i = 0;
      var thumbStart = 0;
      // translate the thumb strip in WHOLE-thumb steps so the active thumb stays
      // in the clipped window and the edge thumb is never cut to a partial sliver.
      function layoutThumbs() {
        if (!thumbtrack || !thumbsEl || !thumbs.length) return;
        var gap = 10;
        var step = thumbs[0].getBoundingClientRect().width + gap;
        if (step <= gap) return;
        var visible = Math.max(1, Math.round((thumbsEl.clientWidth + gap) / step));
        var maxStart = Math.max(0, n - visible);
        if (i < thumbStart) thumbStart = i;
        else if (i > thumbStart + visible - 1) thumbStart = i - visible + 1;
        if (thumbStart > maxStart) thumbStart = maxStart;
        if (thumbStart < 0) thumbStart = 0;
        thumbtrack.style.transform = 'translateX(' + (-thumbStart * step) + 'px)';
      }
      function show(k) {
        i = k < 0 ? 0 : (k > n - 1 ? n - 1 : k);
        track.style.transform = 'translateX(' + (-i * 100) + '%)';   // the slide effect
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
        if (prev) prev.classList.toggle('is-hidden', i === 0);
        if (next) next.classList.toggle('is-hidden', i === n - 1);
        layoutThumbs();
      }
      thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { show(idx); }); });
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      if (viewport) {
        var sx = null;
        viewport.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        viewport.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
          sx = null;
        }, { passive: true });
      }
      show(0);
    });
  }

  /* ---- Curved wave dividers for .berberine-sec--wave (white SVG top + bottom) ---- */
  function initWave() {
    var TOP = '<svg viewBox="0 0 1599 49" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="M1600 48.522L1533.33 45.8263C1466.67 43.1307 1333.33 37.7393 1200 36.8408C1066.67 35.9422 933.333 39.5364 800 43.1307C666.667 46.7249 533.333 50.3191 400 48.522C266.667 46.7249 133.333 39.5364 66.6666 35.9422L0 32.348V3.8147e-06H66.6666C133.333 3.8147e-06 266.667 3.8147e-06 400 3.8147e-06C533.333 3.8147e-06 666.667 3.8147e-06 800 3.8147e-06C933.333 3.8147e-06 1066.67 3.8147e-06 1200 3.8147e-06C1333.33 3.8147e-06 1466.67 3.8147e-06 1533.33 3.8147e-06H1600V48.522Z"/></svg>';
    var BOT = '<svg viewBox="0 0 1600 49" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="M1600 0.478007L1533.33 3.17367C1466.67 5.86934 1333.33 11.2607 1200 12.1592C1066.67 13.0578 933.333 9.46356 800 5.86934C666.667 2.27512 533.333 -1.3191 400 0.478007C266.667 2.27512 133.333 9.46356 66.6666 13.0578L0 16.652V49H66.6666C133.333 49 266.667 49 400 49C533.333 49 666.667 49 800 49C933.333 49 1066.67 49 1200 49C1333.33 49 1466.67 49 1533.33 49H1600V0.478007Z"/></svg>';
    document.querySelectorAll('.berberine-sec--wave').forEach(function (s) {
      if (s.__ppchWave) return;
      s.__ppchWave = true;
      var t = document.createElement('span'); t.className = 'berberine-wave berberine-wave--top'; t.setAttribute('aria-hidden', 'true'); t.innerHTML = TOP;
      var b = document.createElement('span'); b.className = 'berberine-wave berberine-wave--bottom'; b.setAttribute('aria-hidden', 'true'); b.innerHTML = BOT;
      s.insertBefore(t, s.firstChild);
      s.appendChild(b);
    });
  }

  /* ---- Inline video play — NO native controls; the custom play button is the
     only visible control. Tap plays; tap again pauses (play button reappears). ---- */
  function initVideoPlay() {
    document.querySelectorAll('[data-video-play]').forEach(function (item) {
      if (item.__ppchVid) return;
      item.__ppchVid = true;
      var video = item.querySelector('video');
      var btn = item.querySelector('.berberine-vrev__play');
      if (!video) return;
      video.removeAttribute('controls');   // never show native controls
      video.controls = false;
      function toggle() {
        if (video.paused || video.ended) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      }
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
      video.addEventListener('click', toggle);
      // is-playing hides the play button (CSS); removing it brings the play button back
      video.addEventListener('play', function () { video.controls = false; item.classList.add('is-playing'); });
      video.addEventListener('pause', function () { item.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { item.classList.remove('is-playing'); });
    });
  }

  /* ---- Sticky CTA reveal after scrolling past hero ---- */
  function initSticky() {
    var bars = document.querySelectorAll('[data-sticky-cta]');
    if (!bars.length) return;
    bars.forEach(function (b) { b.style.transform = 'translateY(110%)'; b.style.transition = 'transform .3s ease'; });
    function onScroll() {
      var show = window.scrollY > 600;
      bars.forEach(function (b) { b.style.transform = show ? 'translateY(0)' : 'translateY(110%)'; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Smooth scroll for in-page CTA anchors ---- */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---- Interactive 1/2/3-bottle offer selector (sections/berberine-offer.liquid) ----
     Mirrors the assets/berberine-of.js checkout contract: snapshots the cart,
     clears it, then restores the snapshot if adding the offer fails.
     POSTs /cart/add.js with { id: variantId, quantity: data-qty }
     and hands off to /checkout. */
  function initOffer() {
    document.querySelectorAll('[data-berberine-offer]').forEach(function (root) {
      if (root.__ppchOfferBound) return;
      root.__ppchOfferBound = true;

      var sym = root.getAttribute('data-currency') || '$';
      var ctaTpl = root.getAttribute('data-cta-label') || 'ADD TO CART';
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
      var radios = Array.prototype.slice.call(root.querySelectorAll('.berberine-osel__radio'));
      var cta = root.querySelector('[data-offer-cta]');
      var msg = root.querySelector('[data-offer-msg]');
      var amtEl = root.querySelector('[data-total-amt]');
      var saveEl = root.querySelector('[data-total-save]');
      var saveWrap = root.querySelector('[data-total-save-wrap]');
      var row = root.closest ? root.closest('.berberine-of2__row') : null;
      var imageEl = row ? row.querySelector('[data-offer-image]') : null;

      function money(n) {
        var v = (Math.round((Number(n) || 0) * 100) / 100).toFixed(2);
        return sym + v;
      }

      function selectedCard() {
        var checked = root.querySelector('.berberine-osel__radio:checked');
        if (!checked) return cards[0];
        return cards.filter(function (c) {
          var r = c.querySelector('.berberine-osel__radio');
          return r && r.value === checked.value;
        })[0] || cards[0];
      }

      function render() {
        var c = selectedCard();
        if (!c) return;
        cards.forEach(function (x) { x.classList.toggle('is-selected', x === c); });

        var total = parseFloat(c.getAttribute('data-total'));
        var save = parseFloat(c.getAttribute('data-save'));
        var pct = c.getAttribute('data-pct') || '';
        var img = c.getAttribute('data-image') || '';
        var imgAlt = c.getAttribute('data-image-alt') || '';

        if (amtEl) amtEl.textContent = isFinite(total) ? money(total) : money(0);
        if (saveWrap) {
          var hasSave = isFinite(save) && save > 0;
          saveWrap.style.display = hasSave ? '' : 'none';
          if (hasSave && saveEl) saveEl.textContent = money(save);
        }
        if (cta) {
          cta.textContent = ctaTpl.indexOf('{pct}') !== -1
            ? ctaTpl.replace('{pct}', (parseFloat(pct) > 0 ? pct + '%' : ''))
            : ctaTpl;
        }
        if (imageEl && img && imageEl.getAttribute('src') !== img) {
          imageEl.setAttribute('src', img);
          if (imgAlt) imageEl.setAttribute('alt', imgAlt);
        }
      }

      radios.forEach(function (r) { r.addEventListener('change', render); });

      if (cta) {
        cta.addEventListener('click', function (e) {
          e.preventDefault();
          var c = selectedCard();
          var variantId = c ? c.getAttribute('data-variant') : '';
          if (!variantId) {
            if (msg) { msg.textContent = 'This offer is not yet linked to a product. Pick a product in the theme editor.'; msg.className = 'berberine-osel__msg is-error'; }
            return;
          }
          var qty = parseInt(c.getAttribute('data-qty'), 10) || 1;
          var line = { id: Number(variantId), quantity: qty };

          cta.disabled = true;
          cta.style.opacity = '0.7';
          if (msg) { msg.textContent = 'Adding to cart…'; msg.className = 'berberine-osel__msg'; }

          function fail(text) {
            cta.disabled = false;
            cta.style.opacity = '';
            if (msg) { msg.textContent = text; msg.className = 'berberine-osel__msg is-error'; }
          }

          function buildSnapshotItems(cart) {
            return (cart.items || []).map(function (item) {
              var entry = { id: item.variant_id, quantity: item.quantity };
              if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
                entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
              }
              if (item.properties && Object.keys(item.properties).length) {
                entry.properties = item.properties;
              }
              return entry;
            }).filter(function (item) {
              return item.id && item.quantity > 0;
            });
          }

          function restoreSnapshot(snapshotItems) {
            if (!snapshotItems.length) return Promise.resolve();
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: snapshotItems })
            }).catch(function () {});
          }

          function parseCartResponse(r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
              return { ok: r.ok, j: j };
            });
          }

          var snapshotItems = [];
          var cartCleared = false;

          fetch('/cart.js')
            .then(function (r) {
              if (!r.ok) throw new Error('Could not read cart.');
              return r.json();
            })
            .then(function (cart) {
              snapshotItems = buildSnapshotItems(cart);
              return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
            })
            .then(function (r) {
              if (!r.ok) throw new Error('Could not clear cart.');
              cartCleared = true;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [line] })
              });
            })
            .then(parseCartResponse)
            .then(function (res) {
              if (!res.ok) {
                return restoreSnapshot(snapshotItems).then(function () {
                  fail((res.j && res.j.description) ? res.j.description : 'Could not add to cart. Please try again.');
                });
              }
              window.location.href = '/checkout';
            })
            .catch(function (err) {
              var failAfterRestore = function () {
                fail('Could not start checkout: ' + err.message);
              };
              if (cartCleared) {
                restoreSnapshot(snapshotItems).then(failAfterRestore, failAfterRestore);
              } else {
                failAfterRestore();
              }
            });
        });
      }

      render();
    });
  }

  function boot() {
    initAccordion();           // safe to re-run (per-element guard)
    initSwipers();             // safe to re-run (per-element guard)
    initHofGallery();          // safe to re-run (per-element guard)
    initVideoPlay();           // safe to re-run (per-element guard)
    initWave();                // safe to re-run (per-element guard)
    initOffer();               // safe to re-run (per-element guard)
    if (!window.__ppchBootOnce) {
      window.__ppchBootOnce = true;
      initSticky();
      initSmoothScroll();      // document-level delegation — bind once only
    }
    setTimeout(initAccordion, 800); // re-bind after theme-editor DOM updates
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  if (!window.__ppchFunnelSectionLoadBound) {
    window.__ppchFunnelSectionLoadBound = true;
    document.addEventListener('shopify:section:load', boot);
  }
})();
